import removeMarkdown from 'remove-markdown';
import { createTalkFlow } from '@/hooks/apiHooks';

export const createMessageId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const getSseText = (data: Record<string, any>): string | undefined => {
  const payload = data.payload ?? {};
  const result = payload.result ?? data.result ?? {};
  const candidates = [
    payload.message,
    payload.content,
    payload.answer,
    payload.text,
    result.message,
    result.content,
    result.answer,
    result.text,
    data.message,
    data.content,
    data.answer,
    data.text,
  ];

  return candidates.find(
    (candidate) => typeof candidate === 'string' && candidate.trim(),
  );
};

export const stripMarkdown = (markdown: string): string => {
  return removeMarkdown(markdown);
};

export const truncateQuestion = (question: string, maxLength = 27): string => {
  const sanitized = question.replace(/[\r\n]+/g, ' ').trim();
  if (sanitized.length <= maxLength) return sanitized;
  return `${sanitized.slice(0, maxLength)}...`;
};

export const createTalkFlowDocument = (
  content: string,
  fileName: string,
  question: string,
) =>
  createTalkFlow({
    subject: `[${fileName}] "${truncateQuestion(question)}"에 대한 답변`,
    content,
    memo: '',
    participant: {
      internal: [],
      external: [],
    },
    attachments: [],
    relations: [],
    config: {
      meetingDate: '',
      meetingType: 'direct',
      meetingTypeId: '0',
      isTemporary: false,
      meetingMsLink: '',
      meetingMsSubject: '',
      meetingMsId: '',
      documentType: 'new',
    },
  });
